type IfcViewerErrorProps = {
  title?: string;
  message: string;
};

export default function IfcViewerError({ title = "IFC viewer unavailable", message }: IfcViewerErrorProps) {
  return (
    <div className="ifc-error-card" role="alert">
      <h1>{title}</h1>
      <p>{message}</p>
    </div>
  );
}
